/* ==================================================================
   Canais de contato, num lugar só.
   ------------------------------------------------------------------
   ⚠️ TROCAR O NÚMERO AQUI TROCA EM TODO LUGAR. É o ponto do arquivo.

   Ele já morou em sete lugares: aqui, no `legacy.js`, no `Header`, no
   `Footer`, em dois links da home e no JSON-LD do `layout.tsx`. Sete
   cópias de um dado é como um número velho sobrevive a uma troca e
   continua atendendo por meses — que é, em outra roupa, o defeito das
   cinco cópias do preço que o bloco 1 resolveu.

   O navegador recebe o número pelo motor compilado (`motor.js` expõe
   `AgenteMotor.WHATS`), que carrega antes do `legacy.js`. Nada de
   digitar de novo do outro lado.

   ⚠️ FORA DAQUI o número ainda aparece nos PDFs das peças de parceria
   (`saidas/projeto-art/pecas-parceria/visual/`). Peça impressa não se
   corrige depois: ao trocar aqui, regerar os PDFs no mesmo passo.
   ================================================================== */

/** Só dígitos, com país. Formato que o link do WhatsApp exige. */
export const WHATSAPP = "5511912076176";

/** E.164, para `tel:` e para o JSON-LD. Derivado, nunca digitado. */
export const TELEFONE_E164 = `+${WHATSAPP}`;

/** Como o número aparece na tela: (11) 91207-6176 */
export const TELEFONE_EXIBICAO = WHATSAPP.replace(
  /^55(\d{2})(\d{5})(\d{4})$/,
  "($1) $2-$3",
);

export const EMAIL = "contato@artengenharias.com.br";

/** Perfis da marca, no rodapé e no `sameAs` do JSON-LD. O LinkedIn entra
 *  quando existir a página da empresa (`/company/`): o endereço recebido em
 *  12/10 era um perfil pessoal (`/in/`) com nome de empresa. */
export const INSTAGRAM = "https://www.instagram.com/reflectonengenharia/";

/** Quem assina, como aparece nos e-mails e na pasta de documentos.
 *  A home e o prompt do assistente ainda têm o número escrito à mão. */
export const RESPONSAVEL = {
  nome: "Alan Fraga",
  titulo: "engenheiro civil",
  crea: "CREA-SP 5069834367",
} as const;

/** Link de WhatsApp com a mensagem já escrita.
 *  Sem isto o lead chega sem contexto e alguém tem que perguntar
 *  "de onde você veio?" — que é justamente o atrito que o site existe
 *  pra remover. E o texto identifica a página de origem, o que serve
 *  de rastreio de qual conteúdo converte. */
export function whats(mensagem: string): string {
  return `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(mensagem)}`;
}
